import { useMutation } from '@tanstack/react-query';
import { call } from '@/lib/apiClient';
import type { FoxitAnswer } from '@/lib/types';

export const foxitApi = {
  ask: (question: string, history?: { role: 'user' | 'assistant'; content: string }[]) =>
    call<FoxitAnswer>('/foxit/ask', { method: 'POST', body: JSON.stringify({ question, history }) }),
  feedback: (body: { question: string; rating: number; comment?: string; deflected?: boolean; traceId?: string | null }) =>
    call<{ status: string }>('/foxit/feedback', { method: 'POST', body: JSON.stringify(body) }),
};

export function useFoxitAsk() {
  return useMutation({
    mutationFn: (variables: { question: string; history?: { role: 'user' | 'assistant'; content: string }[] }) =>
      foxitApi.ask(variables.question, variables.history),
  });
}

export function useFoxitFeedback() {
  return useMutation({ mutationFn: foxitApi.feedback });
}
